import React from "react";
import { Navigate } from "react-router-dom";

export default function FuerLabelsPage() {
  return <Navigate to="/label-studio" replace />;
}
